/**
 * @description 小小API - https://api.aa1.cn/author/2505
 * @created 2024/04/28 14:15:03
 */
import request from "@/utils/request"
const KEY = "/api-xiaoxiao"

import proxy from "@/configs/proxy"
import { IS_DEV } from "@/constants/is"
const BASE_URL = IS_DEV ? KEY : proxy[KEY].target

/**
 * @description 随机黑丝图片
 * @created 2024/04/28 14:15:18
 * @see https://api.aa1.cn/doc/heisi-xx.html
 * @returns {Object} { code, msg, data }
 */
export function getBlackSilk() {
  return request({
    baseURL: BASE_URL,
    url: "/heisi",
    method: "GET"
  })
}

/**
 * @description 随机白丝图片
 * @created 2024/04/28 14:15:18
 * @see https://api.aa1.cn/doc/baisi-xx.html
 * @returns {Object} { code, msg, data }
 */
export function getWhiteSilk() {
  return request({
    baseURL: BASE_URL,
    url: "/baisi",
    method: "GET"
  })
}

/**
 * @description 随机 4K 图片
 * @created 2024/04/29 10:53:01
 * @see https://api.aa1.cn/doc/random4kPic.html
 * @param {string} type 类型 acg 返回4K二次元图片 | wallpaper 返回4K风景图片
 * @param {string} back 返回类型 json 返回json数据 | 302 302重定向到图片
 * @returns {Object} { code, msg, data }
 */
export function get4KPicture(type, back = "json") {
  return request({
    baseURL: BASE_URL,
    url: "/random4kPic",
    method: "GET",
    params: {
      type,
      return: back
    }
  })
}

/**
 * @description 随机头像
 * @created 2024/04/29 17:06:21
 * @see https://api.aa1.cn/doc/head-xx.html
 * @returns {Object} { code, msg, data }
 */
export function getAvatar() {
  return request({
    baseURL: BASE_URL,
    url: "/head",
    method: "GET"
  })
}

/**
 * @description 随机壁纸
 * @created 2024/04/29 17:09:39
 * @see https://api.aa1.cn/doc/wallpaper.html
 * @returns {Object} { code, msg, data }
 */
export function getWallpaper() {
  return request({
    baseURL: BASE_URL,
    url: "/wallpaper",
    method: "GET"
  })
}

/**
 * @description 随机二次元图片
 * @created 2024/04/29 17:16:13
 * @see https://api.aa1.cn/doc/randomAcgPic.html
 * @param {string} type 类型 pc 返回电脑端二次元图片 | wap 返回手机端二次元图片
 * @param {string} back 返回类型 json 返回json数据 | 302 302重定向到图片
 * @returns {Object} { code, msg, data }
 */
export function getAnimePicture(type, back = "json") {
  return request({
    baseURL: BASE_URL,
    url: "/randomAcgPic",
    method: "GET",
    params: {
      type,
      return: back
    }
  })
}

/**
 * @description 随机美女图片
 * @created 2024/04/29 17:32:27
 * @see https://api.aa1.cn/doc/meinvpic.html
 * @returns {Object} { code, msg, data }
 */
export function getBeautyPicture() {
  return request({
    baseURL: BASE_URL,
    url: "/meinvpic",
    method: "GET"
  })
}
